import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { LqsPage } from "~/lqs/layout";
import { GroupCreateForm } from "./components/GroupCreateForm";

export function NewGroupPage() {
  return (
    <LqsPage title="New Group">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <GroupCreateForm />
      </Container>
    </LqsPage>
  );
}
